import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-communication-chat-locked-icon',
  templateUrl: './communication-chat-locked.component.html'
})
export class CommunicationChatLockedComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
